import produce from 'immer'
import { assign } from 'lodash'

import {
  LOGIN,
  LOGOUT,
  REFRESH_TOKEN,
  UPDATE_ACCESS_TOKEN,
  UPDATE_USER_SETTINGS,
} from '../action-types'
import { ACCOUNT_INITIAL_STATE } from '../initial-states'

const accountReducer = (state = ACCOUNT_INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN.START:
      return produce(state, nextState =>
        assign(nextState, {
          login: {
            isLoading: true,
            error: undefined,
          },
        }),
      )

    case LOGIN.COMPLETE:
      return produce(state, nextState => {
        const { user, accessToken, refreshToken, permissions } =
          action.payload.data.loginWithGoogleIdToken ||
          action.payload.data.loginWithEmailAndCode

        return assign(nextState, {
          user: {
            data: {
              ...user,
              permissions,
            },
            accessToken,
            refreshToken,
          },
          login: {
            isLoading: false,
            error: undefined,
          },
        })
      })

    case LOGIN.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          user: ACCOUNT_INITIAL_STATE.user,
          login: {
            isLoading: false,
            error: action.error.message,
          },
        }),
      )

    case REFRESH_TOKEN.START:
      return produce(state, nextState =>
        assign(nextState, {
          refreshAccessToken: {
            isLoading: true,
            error: undefined,
          },
        }),
      )

    case REFRESH_TOKEN.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          user: {
            ...nextState.user,
            accessToken: action.payload.data.refreshAccessToken,
          },
          refreshAccessToken: {
            isLoading: false,
            error: undefined,
          },
        }),
      )

    case REFRESH_TOKEN.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          user: ACCOUNT_INITIAL_STATE.user,
          refreshAccessToken: {
            isLoading: false,
            error: action.error.message,
          },
        }),
      )

    case UPDATE_ACCESS_TOKEN:
      return produce(state, nextState =>
        assign(nextState, {
          user: { ...nextState.user, accessToken: action.payload.accessToken },
        }),
      )

    case LOGOUT:
      return produce(state, nextState =>
        assign(nextState, {
          user: ACCOUNT_INITIAL_STATE.user,
          login: ACCOUNT_INITIAL_STATE.login,
        }),
      )

    case UPDATE_USER_SETTINGS.START:
      return produce(state, nextState =>
        assign(nextState, {
          updateUserSettings: {
            isLoading: true,
            error: undefined,
          },
        }),
      )

    case UPDATE_USER_SETTINGS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          user: assign(nextState.user, {
            data: {
              ...nextState.user.data,
              settings: {
                ...nextState.user.data.settings,
                ...action.payload.data.updateUserSettings,
              },
            },
          }),
          updateUserSettings: {
            isLoading: false,
            error: undefined,
          },
        }),
      )

    case UPDATE_USER_SETTINGS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          updateUserSettings: {
            isLoading: false,
            error: action.error.message,
          },
        }),
      )

    default:
      return state
  }
}

export default accountReducer
